import React from 'react';

/**
 * One labelled field of a tracking form.
 *
 * Its own component because the two search pages use the same one and the
 * shared `SearchInput` does not fit: that one is the instant filter of a
 * listing, with no label and no submit. Here the visitor types a number they
 * had to go look up, and presses a button when they are done.
 *
 * @param {object} props
 * @param {string} props.id
 * @param {string} props.label
 * @param {string} props.value
 * @param {(value: string) => void} props.onChange
 * @param {string} [props.placeholder]
 * @param {string} [props.type='text']
 * @param {string} [props.hint] - What the number is, in the visitor's words.
 * @param {string} [props.testId]
 */
export const TrackingField = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  hint,
  testId,
}) => (
  <div className="flex flex-col gap-1.5">
    <label htmlFor={id} className="text-sm font-semibold text-ninja-dark dark:text-white">
      {label}
    </label>
    <input
      id={id}
      data-testid={testId}
      type={type}
      value={value}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
      className="w-full px-4 py-3 rounded-xl border border-border bg-white dark:bg-[#111] text-ninja-dark dark:text-white placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-ninja-green/40 focus:border-ninja-green transition-colors"
    />
    {hint && <p className="text-xs text-text-muted">{hint}</p>}
  </div>
);
